import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const FlexContainerReturnRequest2 = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-gap: var(--padding-3);

	@media ${Breakpoints.tablet} {
		grid-template-columns: 1fr;
	}

	&.mobileView {
		grid-template-columns: 1fr;
	}
`;
